import { Person } from "./person";

export class Applicant {
    id: number = 0;
    currentCompany!: string;
    workLocation!: string;
    position!: string;
    baseSalary!: number;

    person: Person = new Person();
}